import * as React from 'react'

import { SoldServiceAppDataModel } from '@user/store/opportunity'

import { DateField } from './DateField'
import { StringField } from './StringField'
import { NumberField } from './NumberField'
import { BooleanField } from './BooleanField'
import { DropdownField } from './DropdownField'

type Props = {
  disabled: boolean
  appData: SoldServiceAppDataModel
}

export function CustomField(props: Props) {
  const { appData, disabled } = props

  switch (appData.type) {
    case 'Dropdown':
      return <DropdownField appData={appData} disabled={disabled} />
    case 'String':
      return <StringField appData={appData} disabled={disabled} />
    case 'Number':
      return <NumberField appData={appData} disabled={disabled} />
    case 'Boolean':
      return <BooleanField appData={appData} disabled={disabled} />
    case 'Date':
      return <DateField appData={appData} disabled={disabled} />
    default:
      return null
  }
}
